
<app-header-inner></app-header-inner>
<!-- Subheader Start -->
<div  class="subheader dark-overlay dark-overlay-2" 
style="padding: 126px 0 2px;min-height: 211px !important;background-image: url('https://s3.eu-central-1.amazonaws.com/heek-media/images/industries/food/food-burger/cover-2.jpg')">
    <div class="container">
      <div class="subheader-inner">
        <h1>{{res_name}}</h1>
        
      </div>

    </div>
  </div>
  <!-- Subheader End -->

  <!-- Menu Categories Start -->
   <!-- You can now use your library component in app.component.html -->
  
  <div class="ct-menu-categories menu-filter" style="    padding-top: 0px;padding-bottom: 0px;">
    <div class="container" style="max-width: 97%;">
	<div class="col-lg-12">
			<div  *ngIf="menuSpin" class="category-box-icon d-flex">
				<i class="fas fa-spinner spinner"></i>
			</div>
		</div>
		<div class="menu-category-slider">
			<div class="row justify-content-md-center">
			<div  *ngFor="let type of orderType;let indexof=index" class="slide col-md-1 col-3">
				<a class="ct-menu-category-item "  (click)="orderReterive(type)">
					<div class="menu-category-desc pt-4 pb-4 " >
						<h6 id="ordertype-{{type}}"class="p-2 menu-class menu-default-border">{{type}}</h6>
					</div>
				</a>
			</div>
			</div>

		</div>
    </div>
  </div>
  <!-- Menu Categories End -->

  <!-- Menu Wrapper Start -->
  <div class="section section-padding">
    <div class="container">

      <div class="row" style="height: auto;">
		<div class="col-lg-12">
			<div  *ngIf="orderSpin" class="category-box-icon d-flex">
				<i class="fas fa-spinner spinner"></i>
			</div>
		</div>
        <!-- Product Start -->
        <div class="col-lg-4 col-md-6 pizzas" *ngFor="let order of orderData">
          <div class="product">
            <div class="product-body ordersBody" >
              <div class="product-desc" (click)="orderDetails(order)">
                <p> <a style="color:white">Order # {{order.order_id}} <span *ngIf="order.order_city!=''">({{order.order_city}})</span></a> </p>
                <p></p>
                <span >
				
				</span>
			  </div>
			<a  class="btn-custom secondary btn-sm shadow-none mt-2" (click)="orderReceipt(order)"> 
			Receipt <i  class="fas fa-receipt" ></i></a>	
            </div>
          </div>
        </div>
        <!-- Product End -->

		<div class="col-lg-12 d-flex justify-content-center">
				<div  *ngIf="loadMoreSpin" class="category-box-icon d-flex">
					<i class="fas fa-spinner spinner"></i>
				</div>
				<button (click)= "loadMore()" *ngIf="!loadMoreSpin && loadMoreShow==1" class="btn btn-danger">Load More</button>
		
		</div>
		

      </div>

    </div>
  </div>
  
<!-- Menu Wrapper End -->
<!-- Modal -->
<div class="modal fade" id="orderDetails" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Order Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="padding-top: 8px;">
		<div class="row">
		
		<div class="col-md-1 col-1 p-0 pl-3">
			<img src="assets/img/status/{{orderstatus}}.png" >
		</div>
		<div class="col-md-10 col-10 p-0 pl-3">
			<b>Order is {{orderstatus}} </b><br>
			<span> {{orderDetailsObject.order_date}}</span><br>
			<span>Order # {{orderDetailsObject.order_id}}</span><br>
			<span>{{orderDetailsObject.store_address}}</span>
		</div>
		
		</div>
		
		<hr >
		<table style="width:100%">
			<tbody *ngFor="let item of orderDetailsObject.order_items">
			<tr>
				<td class="table-td-order-details">{{item.qty}}</td>
				<td class="table-td-order-details">{{item.name}} 
				
				
				</td>
				<td class="table-td-order-details">${{item.ItemBasePrice | number : '1.2-2'}}</td>
			</tr>
			<tr *ngFor="let addon of item.addons;last  as  isLast;" >
				<td class="table-td-order-details" style="border: none;" [ngClass]="{ 'last-addon-td': isLast }"></td>
				<td class="table-td-order-details" style="border: none;" [ngClass]="{ 'last-addon-td': isLast }">
				
				<span *ngIf="addon.pizaextra_name==='left'">
					<i  class="fa fa-adjust fa-3x fa-circel-icon" style="font-size:15px"></i>
				</span>
				<span *ngIf="addon.pizaextra_name==='full'">
					<i  class="fa fa-circle fa-3x fa-circel-icon  " style="font-size:15px"></i>
				</span>
				<span *ngIf="addon.pizaextra_name==='right'">
					<i  class="fa fa-adjust fa-3x fa-rotate-180 " style="font-size:15px"></i>
				</span>
				
				{{addon.name}} <span *ngIf="addon.pizaextra_price_qty>0">X {{addon.pizaextra_price_qty}}</span> </td>
				<td class="table-td-order-details" style="border: none;" [ngClass]="{ 'last-addon-td': isLast }">$
				<span *ngIf="addon.pizaextra_name===''">
				{{addon.amount*item.qty | number : '1.2-2' }}
				</span>
				<span *ngIf="addon.pizaextra_name!=''"> 
					{{addon.pizaextra_price*item.qty | number : '1.2-2' }}
				</span>
				
				</td>
			</tr>
			</tbody>
			
		</table>
		
		<span *ngIf="orderDetailsObject.d_name!=null">Your Delivery driver is {{orderDetailsObject.d_name}}</span>
		<h4>Total {{orderDetailsObject.order_total_price | number : '1.2-2'}}</h4>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div> 

<div class="modal fade" id="orderRecipt" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document" style="margin-top: 0px;">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Order # {{orderDetailsObject.order_id}} Receipt </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="padding-top: 8px;">
		<iframe height="100%" width="100%"
		 id="recipt-iframe"
		 src="">
		</iframe>
		
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="feedbackModal()">Feedback</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>  
<div class="modal fade" id="feedbackModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Feedback Order #{{orderDetailsObject.order_id}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
		<div class="col-12" >
			<p style="text-align:center">To serve you better next time please provide your feedback</p>

			<div style="margin:auto;display:table" class="ratting-stars">
				<i class='fas fa-star start_fill_1 star-ratting' (click)="changeRattingStarts(1)"></i>
				<i class='fas fa-star start_fill_2 star-ratting' (click)="changeRattingStarts(2)"></i>
				<i class='fas fa-star start_fill_3 star-ratting' (click)="changeRattingStarts(3)"></i>
				<i class='fas fa-star start_fill_4 star-ratting' (click)="changeRattingStarts(4)"></i>
				<i class='fas fa-star start_fill_5 star-ratting' (click)="changeRattingStarts(5)"></i>
			</div>
		</div>
		<b>Have some to say? Leave a note below:</b>
		<textarea class="form-control review"></textarea>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <div  *ngIf="loadReviewSpin" class="category-box-icon d-flex">
			<i class="fas fa-spinner spinner"></i>
		</div>
		<button *ngIf="!loadReviewSpin" type="button" class="btn btn-primary" (click)="orderFeedback()"style="border: unset;background:#ba0018">Save changes</button>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
